<template>
  <b-table
    :items="items"
    :fields="fields"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    show-empty
    striped
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(acoes)="item">
      <b-dropdown variant="outline-default" v-if="podeEditar || podeExcluir">
        <b-dropdown-item @click="editar(item.item)" v-if="podeEditar">
          {{ $t('GERAL.EDITAR') }}
        </b-dropdown-item>
        <b-dropdown-item @click="excluir(item.item)" v-if="podeExcluir">
          {{ $t('GERAL.EXCLUIR') }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </b-table>
</template>
<script>
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';
export default {
  mixins: [Permissoes],
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      fields: [
        {
          key: 'codigoBanco',
          label: 'Código',
          sortable: true,
        },
        {
          key: 'descricao',
          label: 'Banco',
          sortable: true,
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
    };
  },
  methods: {
    editar(item) {
      this.$emit('editar', 'banco', item);
    },
    excluir(item) {
      this.$emit('excluir', item);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
